import { FC, ReactElement } from 'react';

import { ConnectedOtherPageRenderer } from '../../connectors';

import './OtherPage.scss';

export const OtherPage: FC = (): ReactElement => (
    <div className="other-page">
        <ConnectedOtherPageRenderer />
    </div>
);
